// @ts-nocheck
import * as Types from "../../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QuerySearchResultsQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  searchKey: Types.Scalars["String"]["input"];
  searchValue: Types.Scalars["String"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type QuerySearchResultsQuery = {
  __typename?: "GraphqlQuery";
  getQueryTagsets: Array<{
    __typename?: "QueryTagset";
    id: string;
    seenAt: number;
    querySample?: {
      __typename?: "QuerySample";
      id: string;
      occurredAt: number;
      queryText: string;
      runtimeMs: number;
      explain?: {
        __typename?: "QueryExplain";
        id: string;
        humanId: string;
        fingerprint: string;
        totalCost?: number | null;
        totalBlkReadTime?: number | null;
        totalSharedBlksRead?: number | null;
        seenAt: number;
        planNodeTypes?: Array<string | null> | null;
      } | null;
    } | null;
    query?: { __typename?: "Query"; id: string } | null;
  }>;
  blockSize?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
};

export const QuerySearchResultsDocument = gql`
  query QuerySearchResults(
    $databaseId: ID!
    $searchKey: String!
    $searchValue: String!
    $startTs: Int!
    $endTs: Int!
  ) {
    getQueryTagsets(
      databaseId: $databaseId
      key: $searchKey
      value: $searchValue
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      seenAt
      querySample {
        id
        occurredAt
        queryText
        runtimeMs
        explain {
          id
          humanId
          fingerprint
          totalCost
          totalBlkReadTime
          totalSharedBlksRead
          seenAt
          planNodeTypes
        }
      }
      query {
        id
      }
    }
    blockSize: getPostgresSettingDetails(
      databaseId: $databaseId
      postgresSettingName: "block_size"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
  }
`;

/**
 * __useQuerySearchResultsQuery__
 *
 * To run a query within a React component, call `useQuerySearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySearchResultsQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      searchKey: // value for 'searchKey'
 *      searchValue: // value for 'searchValue'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useQuerySearchResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  > &
    (
      | { variables: QuerySearchResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  >(QuerySearchResultsDocument, options);
}
export function useQuerySearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  >(QuerySearchResultsDocument, options);
}
// @ts-ignore
export function useQuerySearchResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QuerySearchResultsQuery,
  QuerySearchResultsQueryVariables
>;
export function useQuerySearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QuerySearchResultsQuery,
        QuerySearchResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QuerySearchResultsQuery | undefined,
  QuerySearchResultsQueryVariables
>;
export function useQuerySearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QuerySearchResultsQuery,
        QuerySearchResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QuerySearchResultsQuery,
    QuerySearchResultsQueryVariables
  >(QuerySearchResultsDocument, options);
}
export type QuerySearchResultsQueryHookResult = ReturnType<
  typeof useQuerySearchResultsQuery
>;
export type QuerySearchResultsLazyQueryHookResult = ReturnType<
  typeof useQuerySearchResultsLazyQuery
>;
export type QuerySearchResultsSuspenseQueryHookResult = ReturnType<
  typeof useQuerySearchResultsSuspenseQuery
>;
export type QuerySearchResultsQueryResult = Apollo.QueryResult<
  QuerySearchResultsQuery,
  QuerySearchResultsQueryVariables
>;
